import cx from 'classnames';
import type { FunctionComponent } from 'react';

import PaidFeatureGate from '../Gates/PaidFeatureGate';
import Icon, { icons } from '../Icon';
import type { FossaFeature } from '../../settings/billing/features/consts';

import { useSubnavContext } from './context';
import SubnavItem from './SubnavItem';
import type { SubnavItemProps } from './SubnavItem';

import styles from './Subnav.module.less';

export type SubnavPaidFeatureItemProps = SubnavItemProps & {
  isRestricted?: boolean;
  modalFocusFeature?: FossaFeature;
};

const SubnavPaidFeatureItem: FunctionComponent<SubnavPaidFeatureItemProps> = ({
  to,
  children,
  navKey,
  openInNewTab,
  isRestricted = true,
  modalFocusFeature,
  testId,
}) => {
  const { activeKey } = useSubnavContext();

  if (isRestricted) {
    return (
      <span
        className={cx(styles.link, {
          [styles.linkActive]: activeKey && activeKey === navKey,
        })}
        data-test-id={testId}
      >
        <PaidFeatureGate
          isRestricted={isRestricted}
          modalFocusFeature={modalFocusFeature}
          iconOnly
          hidePill
        >
          <div
            id={`fossa-subnav-${navKey}`}
            className={styles.item}
          >
            {children}
            {' '}
            <Icon icon={icons.lockOutline} />
          </div>
        </PaidFeatureGate>
      </span>
    );
  }

  return (
    <SubnavItem
      to={to}
      navKey={navKey}
      openInNewTab={openInNewTab}
      testId={testId}
    >
      {children}
    </SubnavItem>
  );
};

export default SubnavPaidFeatureItem;
